import { Link } from "react-router-dom";
import { useLocale } from "@/i18n/useLocale";
import { INDUSTRY_PREFIX } from "@/i18n/config";
import { publishedIndustries, localizeIndustry } from "@/data/industries";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import "./IndustryPicker.css";

/**
 * Selector rapido de industria, justo debajo del hero.
 *
 * No es un carrusel/slide automatico -eso tiene problemas de UX conocidos
 * (banner blindness, casi nadie interactua despues de la primera imagen)-:
 * son chips clickeables que llevan directo a /industrias/<rubro>, para que
 * alguien que llega a la home se identifique rapido ("esto es para mi tipo
 * de negocio") sin tener que leer las tres secciones de servicio primero.
 *
 * Seccion propia con fondo oscuro (no un div suelto sobre el blanco de la
 * pagina): antes vivia sin fondo justo debajo del hero y el texto blanco
 * quedaba casi invisible sobre el fondo claro que sigue.
 */
function IndustryPicker() {
  const { t, locale } = useLocale();
  const ref = useScrollReveal<HTMLDivElement>();
  const industries = publishedIndustries.map((i) => localizeIndustry(i, locale));

  return (
    <section className="industry-picker">
      <div className="industry-picker__content" ref={ref}>
        <p className="industry-picker__title">{t.industries.pickerTitle}</p>
        <ul className="industry-picker__list">
          {industries.map((i) => (
            <li key={i.slug}>
              <Link to={`${INDUSTRY_PREFIX[locale]}/${i.slug}`} className="industry-picker__chip">
                {i.shortLabel}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default IndustryPicker;
